<app-modal [(isOpen)]="isOpen" (closeRequested)="onClose()" [closable]="false">
  <ng-container header>
    @if (orderStore.activeVendor(); as vendor) {
      Place Order — {{ vendor.name }}
    } @else {
      Place Order
    }
  </ng-container>

  <form body (ngSubmit)="submit()" [attr.novalidate]="null" id="order-form">
    @if (orderStore.hasSubmittedOrders()) {
      <app-alert variant="notice">Already submitted to {{ submittedVendorNames() }}. Update the fields below and resubmit.</app-alert>
    }

    @if (orderStore.error()) {
      <app-alert variant="error">{{ orderStore.error() }}</app-alert>
    }

    @if (orderStore.activeVendor(); as vendor) {
      <app-dynamic-field-form
        [fields]="vendor.order_fields?.properties ?? {}"
        [required]="vendor.order_fields?.required ?? []"
        [(values)]="formValues"
      />
    }
  </form>

  <div footer class="flex justify-end gap-2">
    <app-button size="small" variant="secondary" (click)="onClose()">
      Cancel
    </app-button>
    @if (orderStore.activeVendorIndex() > 0) {
      <app-button size="small" variant="secondary" (click)="orderStore.previousVendor()">
        Back
      </app-button>
    }
    <app-button size="small" type="submit" form="order-form" [disabled]="orderStore.isSubmitPending()">
      {{ orderStore.isLastVendor() ? (orderStore.hasSubmittedOrders() ? 'Resubmit Order' : 'Submit Order') : 'Next' }}
    </app-button>
  </div>
</app-modal>
